module.exports = __webpack_public_path__ + "static/media/PP_EE_QR_Code_US-(White).39765d8b.gif";